import SimCardType from "../entities/simCardType";

const simCardTypeDataTransformationAfterFetch = (data) => {
  return data.map((row) => {
    return new SimCardType(row);
  });
};

export default simCardTypeDataTransformationAfterFetch;
